import { render } from "./CrowdfundingAddonCardList.vue?vue&type=template&id=4f969569"
import script from "./CrowdfundingAddonCardList.vue?vue&type=script&lang=js"
export * from "./CrowdfundingAddonCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__